module.exports = __webpack_public_path__ + "img/myblu.e03fcbaa.svg";